import {Text} from '@mantine/core';

export const emptyState = (hint: string) => (
    <Text size="sm" c="dimmed" fs="italic">
        {hint}
    </Text>
);
